export const companyLoaded = (company) => {
    return {
        type: 'COMPANY_LOADED',
        payload: company,
    };
};

export const userLoaded = (user) => {
    return {
        type: 'USER_LOADED',
        payload: user,
    };
};

export const cartAdd = (item) => ({ type: 'CART_ADD', payload: item });
export const cartRemove = (key) => ({ type: 'CART_REMOVE', payload: key });
export const cartClear = () => ({ type: 'CART_CLEAR' });
